import { GridProps } from '@chakra-ui/react'

export const formGridStyles: GridProps = {
  templateColumns: { base: '1fr', md: '1fr 1fr' },
  gap: '8px',
}

export const fullWidthStyles: GridProps = {
  gridColumn: '1 / -1',
}
